import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "aria-level"];
import { Heading } from '../Heading/Heading';
import { PageHeadingProvider } from './PageHeadingProvider';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageHeading = _ref => {
  let {
      tagName = 'h1',
      'aria-level': ariaLevel = 1
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const headingStyleOverrides = {
    fontSize: theme.typography['heading-300'].fontSize,
    fontFamily: theme.typography['heading-300'].fontFamily,
    fontWeight: theme.typography['heading-300'].fontWeight,
    margin: theme.space['0']
  };
  return /*#__PURE__*/_jsx(PageHeadingProvider, {
    headingStyleOverrides: headingStyleOverrides,
    children: /*#__PURE__*/_jsx(Heading, Object.assign({
      tagName: tagName,
      "aria-level": ariaLevel
    }, restProps))
  });
};
PageHeading.displayName = 'PageHeading';